<template>
  <div @click="openChat" class="chat-bubble active:ctw-scale-95 ctw-transition-all">
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!isChatOpen">
    <rect x="2.78131" width="61.2187" height="61.2191" rx="30.6093" :fill="primaryColor"/>
    <path d="M43.3326 19.1453H23.4455C21.2565 19.1453 19.4757 20.9261 19.4757 23.1151V36.5372C19.4757 38.7261 21.2565 40.507 23.4455 40.507H25.0033L25.0338 44.0116C25.0365 44.3346 25.222 44.6282 25.5126 44.7694C25.6306 44.8267 25.7578 44.855 25.8843 44.855C26.0691 44.855 26.2524 44.7948 26.4042 44.6777L31.8078 40.5071H43.3326C45.5215 40.5071 47.3024 38.7262 47.3024 36.5373V23.1151C47.3024 20.9261 45.5215 19.1453 43.3326 19.1453Z" :fill="secondaryColor"/>
    <rect x="0.347835" y="3.13031" width="60.523" height="60.5234" rx="30.2615" :stroke="primaryColor" stroke-width="0.695669"/>
    </svg>

    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isChatOpen">
    <rect x="2.78131" width="61.2187" height="61.2191" rx="30.6093" :fill="primaryColor"/>
    <rect x="0.347835" y="3.13031" width="60.523" height="60.5234" rx="30.2615" :stroke="primaryColor" stroke-width="0.695669"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7272 20.7272C24.4301 20.0242 25.5698 20.0242 26.2728 20.7272L34 28.4544L41.7272 20.7272C42.4301 20.0242 43.5698 20.0242 44.2728 20.7272C44.9757 21.4301 44.9757 22.5698 44.2728 23.2727L36.5456 31L44.2728 38.7272C44.9757 39.4301 44.9757 40.5698 44.2728 41.2727C43.5698 41.9757 42.4301 41.9757 41.7272 41.2727L34 33.5455L26.2728 41.2727C25.5698 41.9757 24.4301 41.9757 23.7272 41.2727C23.0243 40.5698 23.0243 39.4301 23.7272 38.7272L31.4544 31L23.7272 23.2727C23.0243 22.5698 23.0243 21.4301 23.7272 20.7272Z" :fill="secondaryColor"/>
    </svg>

  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWidgetStore } from '../store/widget.js';

const widgetStore = useWidgetStore();

const primaryColor = computed(() => widgetStore.primaryColor);
const secondaryColor = computed(() => widgetStore.secondaryColor);
const isChatOpen = computed(() => widgetStore.isChatOpen);


const openChat = () => {
  widgetStore.toggleChat();
};
</script>

<style>
.chat-bubble {
  position: fixed;
  bottom: 20px;
  right: 20px;
  /* Styling */
  cursor: pointer;
}
</style>
